import React from 'react'

import { Link } from 'react-router-dom'
import { Cell, CoinIcon, FormattedCurrency } from '@web/walter-ui-kit'
import styles from './style.module.css'
import { SearchCollectionData } from '~components/PageLayout/types'

interface Props {
    onClick: (code: string) => void
    item: SearchCollectionData
    type?: 'searched' | 'trending'
}

export function SearchMenuItem({ onClick, item, type }: Props) {
    const dataPointer = type ? `${type}_${item.code}` : item.code

    return (
        <div data-pointer={dataPointer} className={styles.wrap} onClick={() => onClick(item.code)}>
            <Link to={item.to || ''} className={styles.link}>
                <Cell
                    padding="l"
                    left={<CoinIcon code={item.code} size="xs" />}
                    title={<span data-pointer="coin_name">{item.name}</span>}
                    details={
                        <div className={styles.details} data-pointer="coin_item">
                            {item.baseBalance ? (
                                <FormattedCurrency
                                    currency={item.code}
                                    value={item.balance}
                                    dataPointer="coin_balance"
                                />
                            ) : (
                                <span data-pointer="coin_code">{item.code}</span>
                            )}
                        </div>
                    }
                />
            </Link>
        </div>
    )
}
